<div class="custom-button-container-right">
  <input type="text"
         [value]="value || ''"
         [readonly]="readonly"
         [disabled]="disabled"
         (change)="onChange($event)">
  <yo-button *ngIf="copy"
             [theme]="ButtonThemeEnum.EMPTY_INNER"
             iconClass="fas fa-copy"
             size="small"
             title="Copier dans le presse-papier"
             (onClick)="copyToClipBoard()"
  >
  </yo-button>
</div>
